export const SimutechBlue = '#003462'
export const SimutechBlueActive = '#002F58'
export const SimutechBlueHighlight = '#E7E9F0'
export const SimutechOrange = '#f47e56'
export const SimutechOrangeActive = '#f15d2c'

export const SelectedRowStyle = {
    backgroundColor: `${SimutechOrangeActive} !important`,
    color: `white !important`,
    '&&:hover': {
        backgroundColor: `${SimutechOrange} !important`,
        color: 'white !important',
    }
}